/** @format */

import * as actionTypes from 'stateContainer/action-types';

const initialState = {
  data: [],
  isFetching: false,
  isUpdating: false,
  isError: false
};

export const brokerProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BROKER_PROFILE_REQUESTED:
      return { ...state, isFetching: true };

    case actionTypes.BROKER_PROFILE_SUCCESS:
      return { ...state, data: action.payload, isFetching: false };

    case actionTypes.BROKER_PROFILE_ERROR:
      return { ...state, isFetching: false, isError: true };

    case actionTypes.BROKER_PROFILE_BY_SLUG_REQUESTED:
      return { ...state, isFetching: true };

    case actionTypes.BROKER_PROFILE_BY_SLUG_SUCCESS:
      return { ...state, data: action.payload, isFetching: false };

    case actionTypes.BROKER_PROFILE_BY_SLUG_ERROR:
      return { ...state, isFetching: false, isError: true };

    case actionTypes.UPDATE_BROKER_REQUESTED:
      return { ...state, isUpdating: true };

    case actionTypes.UPDATE_BROKER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          user: {
            ...state.data.user,
            usp: action.payload.uspsList,
            services: action.payload.servicesList
          }
        },
        isFetching: false,
        isUpdating: false
      };

    case actionTypes.UPDATE_BROKER_ERROR:
      return { ...state, isFetching: false, isError: true, isUpdating: false };

    default:
      return state;
  }
};
